export default __webpack_public_path__ + "static/media/1.7b59c101.png";